goog.provide("shadow.js.shim.module$date_fns$locale$ro$default");
shadow.js.shim.module$date_fns$locale$ro$default = esm_import$date_fns$locale$ro.default;
